<template>
    <h5 class="mb-3" v-if="rolPuedeEditar">Modificar Usuario</h5>
    <h5 class="mb-3" v-if="!rolPuedeEditar">Consultar Usuario</h5>
    <Form role="form"
          class="text-start"
          :validation-schema="schema"
          @submit="handleEditaUsuario"
          >
        <soft-field
            id="username"
            v-model="usuarioEditusername"
            type="text"
            label="Usuario"
            placeholder="Indique su usuario"
            name="username"
            class="mb-3"
            largo="30"
            :readonly="!rolPuedeEditar"
        />

        <soft-field
            id="nombre"
            v-model="usuarioEditName"
            type="text"
            label="Nombre"
            placeholder="Indique su nombre"
            name="nombre"
            class="mb-3"
            largo="80"
            :readonly="!rolPuedeEditar"
        />

        <soft-field
            id="email"
            v-model="usuarioEditemail"
            type="email"
            label="Email"
            placeholder="Indique su email de acceso"
            name="email"
            class="mb-3"
            :readonly="!rolPuedeEditar"
        />

        <soft-select
            id="rolid"
            v-model="usuarioEditrol"
            name="rolid"
            :valores="roles"
            label="Rol"
            placeholder="Seleccione rol"
            class="mb-3"
            :disabled="!rolPuedeEditar"
        />

        <soft-select
            id="departamentoid"
            v-model="usuarioEditdepartamento"
            name="departamentoid"
            :valores="departamentos"
            label="Departamento"
            placeholder="Seleccione departamento"
            class="mb-3"
            :disabled="!rolPuedeEditar"
        />

        <soft-select
            id="oficinaid"
            v-model="usuarioEditoficina"
            name="oficinaid"
            :valores="oficinas"
            label="Oficina"
            placeholder="Seleccione oficina"
            class="mb-3"
            :disabled="!rolPuedeEditar"
        />

        <div class="text-center mt-5">
            <soft-button
                class="my-2 mb-2 text-sm text-analiza-light"
                color="analiza-azul"
                full-width
                :is-disabled="!rolPuedeEditar"
                >
                <span
                    v-if="loading"
                    class="spinner-border spinner-border-sm"
                ></span>
                <span v-else>Confirmar</span>
            </soft-button>
        </div>
    </Form>
  </template>
  
  <script>
  import SoftField from "@/components/SoftField.vue";
  import SoftButton from "@/components/SoftButton.vue";
  import SoftSelect from "@/components/SoftSelect.vue";
  import showSwal from "/src/mixins/showSwal.js";
  import {globalFunctionsMixin} from '@/mixins/globalFunctions.js';
  import { Form } from "vee-validate";
  import * as yup from "yup";

  export default {
    name: "EditaUsuarioForm",
    components: {
        SoftField,
        SoftButton,
        SoftSelect,
        Form,
    },
    props: {
        usuarioId: Number,
        usuarioName: String,
        usuarioUsername: String,
        usuarioEmail: String,
        usuarioRolId: Number,
        usuarioOficinaId: Number,
        usuarioDepartamentoId: Number,
        puedeEditar: Boolean
    },
    mixins: [globalFunctionsMixin],
    data() {
        const schema = yup.object().shape({
            email: yup.string().required("El email es necesario!").email("Debe indicar un email válido"),
            username: yup.string().required("El usuario es necesario!").max(30,'El tamaño máximo es de 30 caracteres').matches(/^[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ.-]+$/, 'El usuario contiene caracteres no permitidos'),
            nombre: yup.string().required("El nombre es necesario!").max(80,'El tamaño máximo es de 80 caracteres'),
            rol_id: yup.number().positive('Debe indicar un rol'),
            departamento_id: yup.number().positive('Debe indicar un departamento'),
            oficina_id: yup.number().positive('Debe indicar una oficina')
        });

        return {
            loading: false,
            schema: schema,
            roles: [],
            departamentos: [],
            oficinas: [],
            user:  {},
            usuarioEditId: this.usuarioId,
            usuarioEditName: this.usuarioName,
            usuarioEditusername: this.usuarioUsername,
            usuarioEditemail: this.usuarioEmail,
            usuarioEditrol: this.usuarioRolId,
            usuarioEditoficina: this.usuarioOficinaId,
            usuarioEditdepartamento: this.usuarioDepartamentoId,
            rolPuedeEditar: this.puedeEditar,
        };
    },
    emits: ['cerrar-modal'],
    methods: {
        async handleEditaUsuario() {
            // Aquí puedes realizar acciones cuando se envía el formulario
            this.loading = true;

                try {             
                    this.loading = false;
                    this.user['id'] = this.usuarioId; 
                    this.user['name'] = this.usuarioEditName; 
                    this.user['username'] = this.usuarioEditusername; 
                    this.user['email'] = this.usuarioEditemail; 
                    this.user['rolid'] = this.usuarioEditrol; 
                    this.user['departamentoid'] = this.usuarioEditdepartamento; 
                    this.user['oficinaid'] = this.usuarioEditoficina; 

                    const resp = await this.$store.dispatch("auth/guardaUsuario", this.user);

                    if (resp.res=='OK') {
                        showSwal.methods.showSwal({
                            type: "success",
                            message: "Se ha actualizado el usuario",
                            width: 600,
                        });
                        this.$emit('cerrar-modal');
                    }
                    else {
                        showSwal.methods.showSwal({
                            type: "error",
                            message: resp.mensaje,
                            width: 500
                        });               
                    }
                } catch (error) {
                    this.loading = false;
                    showSwal.methods.showSwal({
                        type: "error",
                        message: "Se ha producido un error",
                        width: 500,
                    });
                }

        },
    },
    async mounted() {
        this.roles = await this.getRoles();
        this.oficinas = await this.getOficinas();
        this.departamentos = await this.getDepartamentos();
    }
  };
  </script>
  
  <style scoped>
  /* Estilos específicos del componente MyForm */
  </style>
